import PropTypes from 'prop-types';
import React, { useEffect, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import SignupToggleButton from 'components/SignupToggleButton';
import useCustomTranslation from 'hooks/useCustomTranslation';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  Stack,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
  useMediaQuery,
  Link
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useAuth from 'hooks/useAuth';
import useScriptRef from 'hooks/useScriptRef';
// import Google from 'assets/images/icons/social-google.svg';
// import Facebook from 'assets/images/icons/social-facebook.svg'
import AnimateButton from 'ui/AnimateButton';
import { encode as base64Encode } from 'base-64';

// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// ===========================|| FIREBASE - REGISTER ||=========================== //

const FirebaseRegister = ({ registerProp, invitationToken, invitedEmail, plan, ...others }) => {
  // console.log(registerProp)
  // console.log(invitedEmail)
  const theme = useTheme();
  const scriptedRef = useScriptRef();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  const [showPassword, setShowPassword] = React.useState(false);
  const [checked, setChecked] = React.useState(true);
  const [planType, setPlanType] = React.useState(plan || '');

  const [strength, setStrength] = React.useState(0);
  const [level, setLevel] = React.useState();
  const { firebaseRegister, firebaseGoogleSignIn, firebaseFacebookSignIn, getToken } = useAuth();
  // if not prop, use company as default
  const role = registerProp || 'company';
  const [alignment, setAlignment] = React.useState(role);

  const { t } = useCustomTranslation();

  const handleAlignment = (newAlignment) => {
    setAlignment(newAlignment);
    console.log(newAlignment)
  };

  const googleHandler = async () => {
    try {
      await firebaseGoogleSignIn();
    } catch (err) {
      console.error(err);
    }
  };

  const facebookHandler = async () => {
    try {
      await firebaseFacebookSignIn();
    } catch (err) {
      console.error(err);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const changePassword = (value) => {
    // const temp = strengthIndicatorNumFunc(value);
    // setStrength(temp);
    // setLevel(strengthColor(temp));
  };

  const createUser = async (user) => {
    const url = `${process.env.REACT_APP_URL}/create-user`;
    const token = await getToken();

    const headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      headers,
      body: JSON.stringify(user),
      mode: 'cors',
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    };
    fetch(url, requestOptions).then(
      (result) => {
        console.log(result);
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        console.log(error);
        // error();
      }
    );
  }

  const finalizeUser = async (user) => {
    const url = `${process.env.REACT_APP_URL}/create-user`;
    const token = await getToken();

    const headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      headers,
      body: JSON.stringify(user),
      mode: 'cors',
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    };
    fetch(url, requestOptions).then(
      (result) => {
        console.log(result);
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        console.log(error);
        // error();
      }
    );
  }

  useEffect(() => {
    // changePassword('123456');
  }, []);

  return (
    <>
      <Grid container direction="column" justifyContent="center" spacing={2}>
        {/* <Grid item xs={12}>
          <AnimateButton>
            <Button
              variant="outlined"
              fullWidth
              onClick={googleHandler}
              size="large"
              sx={{
                color: 'grey.700',
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 20 : theme.palette.grey[100],
                textTransform: 'none'
              }}
            >
              <Box sx={{ mr: { xs: 1, sm: 2, width: 20 } }}>
                <img src={Google} alt="google" width={16} height={16} style={{ marginRight: matchDownSM ? 8 : 16 }} />
              </Box>
              Sign up with Google
            </Button>
          </AnimateButton>
        </Grid> */}
        {/* <Grid item xs={12}>
          <AnimateButton>
            <Button
              disableElevation
              fullWidth
              onClick={facebookHandler}
              size="large"
              variant="outlined"
              sx={{
                color: 'grey.700',
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[50],
                borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 20 : theme.palette.grey[100],
                textTransform: 'none'
              }}
            >
              <Box sx={{ mr: { xs: 1, sm: 2, width: 20 } }}>
                <img src={Facebook} alt="facebook" width={16} height={16} style={{ marginRight: matchDownSM ? 8 : 16 }} />
              </Box>
              Sign up with Facebook
            </Button>
 */}
        {/* Add Facebook Button, create new methods inside FirebaseContext(temporary) to use in AuthLogin*/}
        {/* </AnimateButton>
        </Grid> */}
      </Grid>

      <Formik
        enableReinitialize
        initialValues={{
          email: invitedEmail || '',
          first_name: '',
          last_name: '',
          password: '',
          role: role // default role based on registerProp
        }}
        validationSchema={Yup.object().shape({
          first_name: Yup.string().max(255).required(t('First name is required')),
          last_name: Yup.string().max(255).required(t('Last name is required')),
          email: Yup.string().email(t('Must be a valid email')).max(255).required(t('Email is required')),
          password: Yup.string().max(255).required(t('Password is required'))
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            await firebaseRegister(values.email, values.password).then(
              (res) => {
                // if (res.user.uid) {
                // }
                values.plan = planType;
                createUser(values);
                console.log(res);

                setStatus({ success: true });
                setSubmitting(false);

                // WARNING: do not set any formik state here as formik might be already destroyed here. You may get following error by doing so.
                // Warning: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application.
                // To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function.
                // github issue: https://github.com/formium/formik/issues/2430
              },
              (err) => {

                console.log(err)
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);

              }
            );
          } catch (err) {
            console.error(err);
            if (scriptedRef.current) {
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
          <form noValidate onSubmit={handleSubmit} {...others}>
            <Grid container spacing={matchDownSM ? 0 : 2}>
              {!registerProp ? (
                <Grid item xs={12} sm={12} mt={5}>
                  <SignupToggleButton alignment={alignment} onChange={handleAlignment} />
                </Grid>
              ) : null}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={t("First name")}
                  margin="normal"
                  name="first_name"
                  type="text"
                  value={values.first_name}
                  onChange={handleChange}
                  sx={{ ...theme.typography.customInput }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={t("Last name")}
                  margin="normal"
                  name="last_name"
                  type="text"
                  value={values.last_name}
                  onChange={handleChange}
                  sx={{ ...theme.typography.customInput }}
                />
              </Grid>
            </Grid>
            <FormControl fullWidth error={Boolean(touched.email && errors.email)} sx={{ ...theme.typography.customInput }}>
              <InputLabel htmlFor="outlined-adornment-email-register">{t('Email address')}</InputLabel>
              <OutlinedInput
                id="outlined-adornment-email-register"
                type="email"
                value={values.email}
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                inputProps={{
                  readOnly: !!invitationToken, // optional, ensures user can’t type
                }}
                disabled={!!invitationToken}
              />
              {touched.email && errors.email && (
                <FormHelperText error id="standard-weight-helper-text--register">
                  {errors.email}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              error={Boolean(touched.password && errors.password)}
              sx={{ ...theme.typography.customInput }}
            >
              <InputLabel htmlFor="outlined-adornment-password-register">{t('Password')}</InputLabel>
              <OutlinedInput
                id="outlined-adornment-password-register"
                type={showPassword ? 'text' : 'password'}
                value={values.password}
                name="password"
                label={t("Password")}
                onBlur={handleBlur}
                onChange={(e) => {
                  handleChange(e);
                  changePassword(e.target.value);
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      size="large"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                inputProps={{}}
              />
              {touched.password && errors.password && (
                <FormHelperText error id="standard-weight-helper-text-password-register">
                  {errors.password}
                </FormHelperText>
              )}
            </FormControl>

            {/* add invitationcode field if exists */}
            {invitationToken && (
              <TextField
                fullWidth
                label="Invitation Code"
                margin="normal"
                name="invitation_code"
                type="text"
                value={invitationToken}
                hidden
                sx={{ ...theme.typography.customInput, display: 'none' }}
              />
            )}

            {strength !== 0 && (
              <FormControl fullWidth>
                <Box sx={{ mb: 2 }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      <Box
                        style={{ backgroundColor: level?.color }}
                        sx={{ width: 85, height: 8, borderRadius: '7px' }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="subtitle1" fontSize="0.75rem">
                        {level?.label}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </FormControl>
            )}

            {/* <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(event) => setChecked(event.target.checked)}
                      name="checked"
                      color="primary"
                    />
                  }
                  label={
                    <Typography variant="subtitle1">
                      Agree with&nbsp;
                      <Link href="/terms-of-use" target="_blank" sx={{ color: theme.palette.grey[900], textDecorationColor: theme.palette.grey[900] }}>
                        Terms of use
                      </Link>
                    </Typography>
                  }
                />
              </Grid>
            </Grid> */}
            {errors.submit && (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Box>
            )}

            <Box sx={{ mt: 2 }}>
              <AnimateButton>
                <Button
                  disableElevation
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: 'none' }}
                >
                  {t('Sign up')}
                </Button>
              </AnimateButton>
            </Box>
          </form>
        )}
      </Formik>
    </>
  );
};

FirebaseRegister.propTypes = {
  loginProp: PropTypes.string
};

export default FirebaseRegister;
